import Input from "components/common/Input";
import Selector from "components/common/Selector";
import Checkbox from "components/common/Checkbox";
import InputTextArea from "components/common/InputTextArea";
import TagIcon from "components/icons/TagIcon";
import ImageIcon from "components/icons/ImageIcon";
import CloseIconSmall from "components/icons/CloseIconSmall";
import ColorSelector from "components/common/ColorSelector";
import Colors from "assets/Colors.js";
import Button from "components/common/Button";
import { useState } from "react";
import { Col, Row } from "antd";
import CustomSelector from "components/common/Selector";
import useScreenSize from "hooks/useScreenSize";
import { useTranslation } from "react-i18next";
import s from "../../../../styles/GeneralBody.styles";
import { useCategoryAndSubcategorySelector } from "../../../../helpers/hooks";
import AddSubCategoryModal from "../../../../components/common/AddSubCategoryModal";
import AddCategoryModal from "../AddCategoryModal";
import Modal from "../../../../components/common/Modal";
import useTaxes from "../../../../graphql/useTaxes";
import InputNumber from "../../../../components/common/InputNumber";

function GeneralBody({
  handleChange,
  values,
  setFieldValue,
  skuExists,
  getFieldProps,
  touched,
  errors,
}) {
  const { t } = useTranslation();
  const [addCategoryPopUp, setAddCategoryPopUp] = useState("");
  const { taxes, loading: loadingTaxes } = useTaxes();

  const {
    categoryId,
    setCategoryId,
    subcategoryOptions,
    categories,
    categoryMap,
  } = useCategoryAndSubcategorySelector(values.subcategoryId);

  const [tagInputValue, setTagInputValue] = useState("");
  // const [type, setType] = useState("common");
  const [priceForValue, setPriceForValue] = useState(
    values?.measureUnit || "unit"
  );

  const { width } = useScreenSize();

  const priceFor = [
    { for: t("Items.unit"), value: "unit" },
    { for: "g", value: "g" },
    { for: "100g", value: "100g" },
    { for: "kg", value: "kg" },
    { for: t("Items.pound"), value: "pound" },
    { for: t("Items.onz"), value: "onz" },
  ];

  const handleUseScale = (e) => {
    setPriceForValue(e);
    if (e === "unit") {
      setFieldValue("useScale", false);
      setFieldValue("measureUnit", null);
    } else {
      setFieldValue("useScale", true);
      setFieldValue("measureUnit", e);
    }
  };

  //
  const onChange = (e) => {
    setFieldValue("type", e);
    if (e === "common") {
      setFieldValue("mixAndMatch", undefined);
    } else if (e === "mix&match") {
      setFieldValue("mixAndMatch", {
        steps: [
          {
            name: "",
            items: [
              {
                items: [],
                quantity: "1",
                price: "",
              },
            ],
          },
        ],
      });
    }
  };

  return (
    <>
      <s.TopSectionsContainer
        style={{
          display: "flex",
        }}
      >
        <s.LeftContainer>
          <s.SectionTitle style={{ marginBottom: "18px" }}>
            {t("Items.generalInfo")}
          </s.SectionTitle>
          <s.Line style={{ marginBottom: "10px" }} />

          <Row gutter={10}>
            <Col span={7}>
              <s.SubTitle>{t("Items.fields.type.label")}</s.SubTitle>
              <CustomSelector
                borderColor={Colors.background_dividers}
                options={[
                  {
                    name: t("Items.fields.type.simple"),
                    value: "common",
                  },
                  {
                    name: t("Items.fields.type.compound"),
                    value: "mix&match",
                  },
                ]}
                style={{ width: "100%" }}
                value={values.type}
                onChange={onChange}
              />
            </Col>
            <Col span={17}>
              <s.SubTitle>{t("Items.fields.name.label")}*</s.SubTitle>
              <Input
                placeholder={t("Items.fields.name.placeholder")}
                style={{
                  marginBottom: "27px",
                }}
                name="name"
                valid={errors.name}
                value={values.name}
                {...getFieldProps("name")}
              />
              {errors.name && (
                <s.messageAlert>{t("formValidations.required")}</s.messageAlert>
              )}
            </Col>
          </Row>

          <s.SubTitle>{t("Items.fields.invoiceName.label")}</s.SubTitle>
          <Input
            style={{
              marginBottom: "10px",
            }}
            placeholder={t("Items.fields.invoiceName.placeholder")}
            name="invoiceName"
            value={values.invoiceName}
            onChange={handleChange}
          />
          <s.LittleMessage>
            {t("Items.fields.invoiceName.message")}
          </s.LittleMessage>

          <s.SameLineInputsContainer style={{ marginBottom: "31px" }}>
            <s.SmallInputContainerAndTitle style={{ marginRight: "9px" }}>
              <s.SectionTitle2>{t("Items.fields.sku.label")}*</s.SectionTitle2>
              <Input
                placeholder={t("Items.fields.sku.placeholder")}
                style={{
                  width: width < 720 ? "100%" : "160px",
                }}
                name="sku"
                value={values.sku}
                valid={touched.sku && errors.sku}
                {...getFieldProps("sku")}
              />
              {skuExists && (
                <s.LittleMessage style={{ color: "red" }}>
                  {t("Items.fields.sku.existSku")}
                </s.LittleMessage>
              )}
            </s.SmallInputContainerAndTitle>

            <s.SmallInputContainerAndTitle
              style={{ marginRight: "9px", marginTop: width < 720 && "20px" }}
            >
              <s.SectionTitle2>
                {t("Items.fields.price.label")}*
              </s.SectionTitle2>
              <InputNumber
                placeholder={t("Items.fields.price.placeholder")}
                style={{
                  width: width < 720 ? "100%" : "160px",
                }}
                name="price"
                disabled={values.alwaysAskPrice}
                value={values.price}
                valid={touched.price && errors.price}
                onChange={(value) => setFieldValue("price", value)}
              />
              {touched.price && errors.price && (
                <s.messageAlert style={{ marginTop: "5px" }}>
                  {t("formValidations.required")}
                </s.messageAlert>
              )}
            </s.SmallInputContainerAndTitle>

            <s.SmallInputContainerAndTitle
              style={{ marginTop: width < 720 && "20px" }}
            >
              <s.SectionTitle2 style={{ marginBottom: "0px" }}>
                {t("Items.fields.useScale.label")}
              </s.SectionTitle2>
              <s.SameLineInputsContainer>
                <Selector
                  borderColor={Colors.background_dividers}
                  options={priceFor?.map((s) => ({
                    name: s.for,
                    value: s.value,
                  }))}
                  style={{
                    width: width < 720 ? width - 24 : 132,
                    marginRight: 9,
                    marginTop: "9px",
                  }}
                  value={priceForValue}
                  onChange={(value) => handleUseScale(value)}
                />
              </s.SameLineInputsContainer>
            </s.SmallInputContainerAndTitle>

            <s.SmallInputContainerAndTitle
              style={{ marginTop: width < 720 && "20px" }}
            >
              <s.SectionTitle2 style={{ marginBottom: "0px" }}>
                {t("Items.fields.tax1.label")}*
              </s.SectionTitle2>
              <s.SameLineInputsContainer>
                <Selector
                  name="taxes"
                  borderColor={
                    !errors.tax1
                      ? Colors.background_dividers
                      : Colors.notification_failed
                  }
                  disabled={loadingTaxes}
                  options={taxes.map((s) => ({
                    name: s.name,
                    value: s._id,
                  }))}
                  style={{
                    width: width < 720 ? width - 24 : 132,
                    marginRight: 9,
                    marginTop: "9px",
                  }}
                  placeholder={t("Items.fields.tax1.placeholder")}
                  value={values.tax1}
                  onChange={(value) => {
                    handleChange({
                      target: {
                        name: "tax1",
                        value,
                      },
                    });
                  }}
                />
              </s.SameLineInputsContainer>
              {errors.tax1 && (
                <s.messageAlert style={{ marginTop: "5px" }}>
                  {t("formValidations.required")}
                </s.messageAlert>
              )}
            </s.SmallInputContainerAndTitle>
          </s.SameLineInputsContainer>
        </s.LeftContainer>

        <s.RightContainer>
          <s.SectionTitle style={{ marginBottom: "18px" }}>
            {t("Items.fields.image.label")}
          </s.SectionTitle>
          <s.PhotoSectionMiddle>
            <s.ImageContainer style={{ background: values.color }}>
              {!values.color && <ImageIcon />}
            </s.ImageContainer>
            <s.TextImageContainer>
              <div style={{ marginBottom: "16px" }}>
                {t("imagePicker.addImage")}
              </div>
              <div> {t("imagePicker.takeAPicture")}</div>
            </s.TextImageContainer>
          </s.PhotoSectionMiddle>
          <s.LittleMessage style={{ marginTop: "13px", marginBottom: "18px" }}>
            {t("imagePicker.message")}
          </s.LittleMessage>
          <s.SubTitle style={{ marginBottom: "13px" }}>
            {t("imagePicker.takeAPicture")}
          </s.SubTitle>
          <ColorSelector
            handleChange={(value) => {
              handleChange({
                target: {
                  name: "color",
                  value,
                },
              });
            }}
          />
        </s.RightContainer>
      </s.TopSectionsContainer>

      <Row style={{ marginBottom: width < 720 ? "30px" : "54px" }}>
        <Col xs={24} md={8}>
          <Checkbox
            name="alwaysAskPrice"
            onChange={() => [
              handleChange({
                target: {
                  name: "alwaysAskPrice",
                  value: !values.alwaysAskPrice,
                },
              }),
              setFieldValue("price", "0"),
            ]}
            checked={values.alwaysAskPrice}
            style={{ marginBottom: width < 720 ? "10px" : "19px" }}
          >
            {t("Items.fields.alwaysAskPrice.label")}
          </Checkbox>
          <Checkbox
            name="pinToStart"
            onChange={handleChange}
            checked={values.pinToStart}
            style={{ marginBottom: width < 720 ? "10px" : "0" }}
          >
            {t("Items.fields.pinToStart.label")}
          </Checkbox>
        </Col>
        <Col xs={24} md={8}>
          <Checkbox
            name="hidden"
            onChange={handleChange}
            checked={values.hidden}
            style={{ marginBottom: width < 720 ? "10px" : "19px" }}
          >
            {t("Items.fields.hidden.label")}
          </Checkbox>
          <Checkbox
            name="includesCommission"
            onChange={handleChange}
            checked={values.includesCommission}
            style={{ marginBottom: width < 720 ? "10px" : "0px" }}
          >
            {t("Items.fields.includesCommission.label")}
          </Checkbox>
        </Col>
        <Col xs={24} md={8}>
          <Checkbox
            name="favorite"
            onChange={handleChange}
            checked={values.favorite}
            style={{ marginBottom: width < 720 ? "10px" : "19px" }}
          >
            {t("Items.fields.favorite.label")}
          </Checkbox>
          <Checkbox
            name="disabled"
            onChange={handleChange}
            checked={values.disabled}
          >
            {t("Items.fields.disabled.label")}
          </Checkbox>
        </Col>
      </Row>

      <s.SectionTitle style={{ marginBottom: "18px" }}>
        {t("Items.catAndSubCategories")}
      </s.SectionTitle>
      <s.Line style={{ marginBottom: "10px" }} />

      <s.CategoriesContainer>
        <div style={{ marginRight: "100px" }}>
          <s.SubTitle style={{ marginBottom: "0px" }}>
            {t("Items.fields.category.label")}*
          </s.SubTitle>
          <s.SelectorAndButtonContainer>
            <Selector
              borderColor={
                !errors.subcategoryId || categoryId
                  ? Colors.text_secondary
                  : Colors.notification_failed
              }
              options={categories
                .map((s) => ({
                  name: s.name || "-",
                  value: s._id,
                }))
                .sort((a, b) => a.name.localeCompare(b.name))}
              style={{
                width: width < 720 ? width - 24 : 238,
                marginTop: "8px",
                marginRight: "9px",
              }}
              placeholder={t("actions.select")}
              value={categoryId}
              onChange={(value) => {
                setCategoryId(value);
                handleChange({
                  target: {
                    name: "subcategoryId",
                    value: undefined,
                  },
                });
              }}
            />

            <Button
              type="primary"
              style={{
                background: Colors.primary,
                color: Colors.text_on_secondary,
                width: "169px",
                fontWeight: "500",
                border: "none",
                borderRadius: "5px",
                height: "40px",
                marginTop: width < 720 ? "20px" : "8px",
                marginBottom: width < 720 ? "20px" : "8px",
              }}
              onClick={() => setAddCategoryPopUp("category")}
            >
              {t("Items.fields.category.button")}
            </Button>
            {!(!errors.subcategoryId || categoryId) && (
              <s.messageAlert style={{ marginTop: "5px", width: "100%" }}>
                {t("formValidations.required")}
              </s.messageAlert>
            )}
          </s.SelectorAndButtonContainer>
        </div>
        <div>
          <s.SubTitle style={{ marginBottom: "0px" }}>
            {t("Items.fields.subCategory.label")}*
          </s.SubTitle>
          <s.SelectorAndButtonContainer>
            <Selector
              disabled={!categoryId}
              placeholder={t("actions.select")}
              borderColor={
                !errors.subcategoryId
                  ? Colors.text_secondary
                  : Colors.notification_failed
              }
              options={subcategoryOptions
                .map((s) => ({
                  name: s.name,
                  value: s._id,
                }))
                .sort((a, b) => a.name.localeCompare(b.name))}
              style={{
                width: width < 720 ? width - 24 : 238,
                marginTop: "8px",
                marginRight: "9px",
              }}
              value={values.subcategoryId}
              onChange={(value) => {
                handleChange({
                  target: {
                    name: "subcategoryId",
                    value,
                  },
                });
              }}
            />
            <Button
              disabled={!categoryId}
              type="primary"
              style={{
                background: !categoryId
                  ? `${Colors.primary}30`
                  : Colors.primary,
                color: Colors.text_on_secondary,
                width: "169px",
                fontWeight: "500",
                border: "none",
                borderRadius: "5px",
                height: "40px",
                marginTop: width < 720 ? "20px" : "8px",
              }}
              onClick={() => setAddCategoryPopUp("subcategory")}
            >
              {t("Items.fields.subCategory.button")}
            </Button>
          </s.SelectorAndButtonContainer>
          {errors.subcategoryId && (
            <s.messageAlert style={{ marginTop: "5px" }}>
              {t("formValidations.required")}
            </s.messageAlert>
          )}
        </div>
      </s.CategoriesContainer>
      <s.SectionTitle style={{ marginTop: "54px", marginBottom: "18px" }}>
        {t("Items.fields.tags.label")}
      </s.SectionTitle>
      <s.Line style={{ marginBottom: "10px" }} />
      <s.TagsWrapper>
        <Input
          placeholder={t("Items.fields.tags.placeholder")}
          style={{
            marginBottom: "7px",
            maxWidth: "212px",
            marginRight: "9px",
          }}
          prefix={<TagIcon />}
          onChange={(e) => setTagInputValue(e.target.value)}
          value={tagInputValue}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleChange({
                target: {
                  name: "tags",
                  value: [...values.tags, tagInputValue.trim()],
                },
              });
              setTagInputValue("");
            }
          }}
        />
        {values?.tags?.map((tag, i) => (
          <s.TagContainer key={i + tag}>
            {tag}
            <s.TagCloseIconContainer
              onClick={() => {
                handleChange({
                  target: {
                    name: "tags",
                    value: values.tags.filter((v) => v !== tag),
                  },
                });
              }}
            >
              <CloseIconSmall />
            </s.TagCloseIconContainer>
          </s.TagContainer>
        ))}
      </s.TagsWrapper>
      <Row>
        <s.SectionTitle style={{ marginTop: "52px", marginBottom: "18px" }}>
          {t("Items.fields.description.label")}
        </s.SectionTitle>
        <s.Line style={{ marginBottom: "23px" }} />
        <Col span={24}>
          <InputTextArea
            style={{
              height: "101px",
            }}
            placeholder={t("Items.fields.description.placeholder")}
            name="description"
            value={values.description}
            onChange={handleChange}
          />
        </Col>
      </Row>

      {addCategoryPopUp === "subcategory" && (
        <Modal onCancel={() => setAddCategoryPopUp("")} visible>
          <AddSubCategoryModal
            close={() => setAddCategoryPopUp("")}
            setNewSubCategory={(id) => {
              handleChange({
                target: {
                  name: "subcategoryId",
                  value: id,
                },
              });
            }}
            parentCategory={{
              name: categoryMap[categoryId].name,
              id: categoryId,
            }}
          />
        </Modal>
      )}
      {addCategoryPopUp === "category" && (
        <Modal onCancel={() => setAddCategoryPopUp("")} visible>
          <AddCategoryModal
            close={() => {
              setAddCategoryPopUp("");
            }}
            onCategoryCreated={(category) => {
              setCategoryId(category._id);
              handleChange({
                target: {
                  name: "subcategoryId",
                  value: undefined,
                },
              });
            }}
          />
        </Modal>
      )}
    </>
  );
}

export default GeneralBody;
